import { render, staticRenderFns } from "./ToolsPanel.vue?vue&type=template&id=5d3d82d6&"
import script from "./ToolsPanel.vue?vue&type=script&lang=js&"
export * from "./ToolsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports